export default {
      id: "checkbox_checked-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#checkbox_checked",
      toString: function () {
        return this.url;
      }
    }